import { render, staticRenderFns } from "./trainBase.vue?vue&type=template&id=e2e188fe&scoped=true&"
import script from "./trainBase.vue?vue&type=script&lang=js&"
export * from "./trainBase.vue?vue&type=script&lang=js&"
import style0 from "./trainBase.vue?vue&type=style&index=0&id=e2e188fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e188fe",
  null
  
)

export default component.exports